"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _Popover = _interopRequireDefault(require("@material-ui/core/Popover"));
var _SttAppsButton = _interopRequireDefault(require("./SttButton/SttAppsButton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    menuButton: {
      fontSize: theme.spacing(3),
      color: '#fff',
      margin: 'auto'
    }
  };
});
var StyledMenu = (0, _styles.withStyles)({
  paper: {
    border: '1px solid #d3d4d5',
    height: '250px',
    overflow: 'hidden'
  }
})(function (props) {
  return /*#__PURE__*/_react["default"].createElement(_Popover["default"], _extends({
    elevation: 0,
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    }
  }, props));
});
var time = new Date().getTime();
function SttMenuModulos(_ref) {
  var config = _ref.config;
  var _React$useState = _react["default"].useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    anchor = _React$useState2[0],
    setAnchor = _React$useState2[1];
  var classes = useStyles();
  var handleClose = function handleClose() {
    setAnchor(null);
  };
  var handleOpenMenu = function handleOpenMenu(event) {
    setAnchor(event.currentTarget);
  };
  return config ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_SttAppsButton["default"], {
    className: classes.menuButton,
    onClick: handleOpenMenu
  }), /*#__PURE__*/_react["default"].createElement(StyledMenu, {
    anchorEl: anchor,
    keepMounted: true,
    open: Boolean(anchor),
    onClose: handleClose
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    referrerPolicy: "unsafe-url",
    src: "".concat(config.url_base_oauth2, "/MenuModulosManager?moduloAtual=").concat(config.modulo_nome, "&v=").concat(time),
    style: {
      width: '350px',
      height: '100%',
      border: 0,
      position: 'relative'
    }
  }))) : '';
}
var _default = SttMenuModulos;
exports["default"] = _default;